import { Build } from '@stencil/core';

// focus options

import 'focus-options-polyfill';

// scroll-behaviour

if (!('scrollBehavior' in document.documentElement.style)) {
  setTimeout((_) => {
    import(
      /* webpackChunkName: 'polyfills-scroll-behavior' */ 'scroll-behavior-polyfill'
    ).then((_) => {
      document.documentElement.style.scrollBehavior = 'smooth';
    });
  }, 0);
} else document.documentElement.style.scrollBehavior = 'smooth';

// fire global 'ready' event when everything is hydrated

if (Build.isBrowser) {
  const docEle = document.documentElement;
  const docIsReady = () => {
    if (!docEle.classList.contains('hydrated')) return false;
    document.documentElement.dispatchEvent(
      new CustomEvent('nanoComponentsReady')
    );
    return true;
  };

  if (!docIsReady()) {
    let mutationO = new MutationObserver((_) => {
      if (docIsReady()) {
        mutationO.disconnect();
        mutationO = null;
      }
    });

    mutationO.observe(document.documentElement, {
      childList: false,
      subtree: false,
      attributes: true,
    });
  }
}
